import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgTagsIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="tags_svg__nc-icon-wrapper">
      <path d="M55.535 35.121 28.707 8.293A1 1 0 0 0 28 8H4a1 1 0 0 0-1 1v24a1 1 0 0 0 .293.707l26.828 26.828a5.006 5.006 0 0 0 7.071 0l18.343-18.343a5.006 5.006 0 0 0 0-7.071ZM18 28a5 5 0 1 1 5-5 5 5 0 0 1-5 5Z" />
      <path
        d="M28 5a3.971 3.971 0 0 1 2.828 1.172l25.621 25.621L59.242 29 32.121 1.879A3 3 0 0 0 30 1H8a1 1 0 0 0-1 1v3Z"
        data-color="color-2"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgTagsStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgTagsIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const TagsIcon: any = SvgTagsStyle;
export default TagsIcon;
